@if (parentFormGroup.controls[controlName]) {
  <mat-form-field
    [formGroup]="parentFormGroup"
    appearance="fill"
    class="form-field w-full"
    floatLabel="always"
    hideRequiredMarker
    >
    @if (label) {
      <mat-label
        [class.error]="error"
        class="text-type-13">
        {{ label }}@if (isRequired) {
        <span>*&nbsp;</span>
        }:
        @if (labelBadge) { <span class="field-label-badge" data-testid="field-label-badge">{{ labelBadge }}</span> }
      </mat-label>
    }
    @if (!isDisabled) {
      <mat-icon
        #trigger="cdkOverlayOrigin" (click)="toggleOverlay()"
        cdkOverlayOrigin
        class="suffix cursor-pointer"
        matSuffix
        svgIcon="time-picker"
      ></mat-icon>
    }
    <input
      #input
      (focus)="toggleOverlay()"
      [formControlName]="controlName"
      [max]="max"
      [maxlength]="maxLength"
      [min]="min"
      class="input number-input"
      matInput
      placeholder="{{placeholder}}"
      readonly
      type="text"
      >
    @if (error) {
      <mat-error>{{ error }}</mat-error>
    }
    @if (!error && warning) {
      <mat-hint class="text-type-14 warning">{{ warning }}</mat-hint>
    }
    @if (!error && !warning && hint) {
      <mat-hint class="text-type-14">{{ hint }}</mat-hint>
    }
  </mat-form-field>
}

<ng-template
  (backdropClick)="closeOverlay()"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  [cdkConnectedOverlayHasBackdrop]="menuOpen"
  [cdkConnectedOverlayOpen]="menuOpen"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayPanelClass]="['z-1002','time-select']"
  [cdkConnectedOverlayPositions]="overlayPositions"
  cdkConnectedOverlay
  >
  <div class="custom-options rounded-[8px] bg-white border border-gray-300 shadow-md mt-[12px]">
    <div class="form-section flex-1 p-[10px] w-[295px] min-h-[95px]">
      <div
        class="row flex flex-row justify-center items-center w-full gap-[15px] mt-[12px]"
        >
        <app-time-input
          [controlName]="timePeriodControlName"
          [parentFormGroup]="parentFormGroup"
          class="w-[50%]"
          label="time"
          />
        <app-toggle-buttons
          [buttonLabels]="labels"
          [controlName]="amPmControlName"
          [parentFormGroup]="parentFormGroup"
          class="time-toggle-btn w-[50%]"
          />
      </div>
    </div>
  </div>
</ng-template>
